import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    LaneGroupTemperatureRange,
    ProductType,
} from 'app/enums/label.enums'
import laneRequests from 'app/requests/Lane/Lane.requests'
import contractBasisRequests from 'app/requests/ContractBasis/ContractBasis.requests'

const useGetProductTypes = ({
    leaseStartTimestamp,
    selectedLaneId,
    tempRange: selectedTempRange,
}: {
    selectedLaneId: number,
    leaseStartTimestamp: string,
    tempRange: LaneGroupTemperatureRange,
}): ProductType[] => {
    const {
        data: allowedProductTypes,
    } = useRequest<ProductType[]>({
        key: RequestKeys.getAllowedProductTypes,
        params: {
            laneId: selectedLaneId,
            leaseStartTimestamp,
            isPerformanceQualification: false,
        },
        requestFunc: RequestFn.getEntity(laneRequests.laneAllowedProductTypes),
        enabled: Boolean(selectedLaneId && leaseStartTimestamp),
    })

    const {
        data: allProductTypes,
    } = useRequest<ProductType[]>({
        key: RequestKeys.getProductTypesContractBasis,
        params: {
            selectedTempRange,
        },
        requestFunc: RequestFn.getEntity(contractBasisRequests.getAllProductTypes, (promise) => {
            return promise.then((resp) => {
                return resp.data.reduce((acc, {
                    productType,
                    temperatureRange,
                }) => {
                    if (selectedTempRange === temperatureRange) {
                        return [
                            ...acc,
                            productType,
                        ]
                    }

                    return acc
                }, [])
            })
        }),
        enabled: Boolean(!selectedLaneId),
    })

    return selectedLaneId ? allowedProductTypes : allProductTypes
}

export default useGetProductTypes
